/* import __COLOCATED_TEMPLATE__ from './survey-nps-counter-chart.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import ChartDataResource from 'embercom/lib/reporting/chart-data-resource';
import { useResource } from 'ember-resources';
import Formatters from 'embercom/lib/reporting/flexible/formatters';
import percent, { REPORTS_WHOLE_NUMBER_PRECISION } from 'embercom/lib/percentage-formatter';
import {
  NPS_DETRACTORS_RATING_THRESHOLD,
  NPS_PASSIVES_RATING_THRESHOLD,
  NPS_PROMOTERS_RATING_THRESHOLD,
} from 'embercom/lib/reporting/survey-helpers';
import { cached } from 'tracked-toolbox';

export default class SurveyNpsCounterChart extends Component {
  loadingIndicatorSize = 'large';
  size = '1';

  dataResource = useResource(this, ChartDataResource, () => ({
    renderableChart: this.args.renderableChart,
  }));

  @cached
  get bucketCounts() {
    let detractors = 0;
    let passives = 0;
    let promoters = 0;

    if (this.hasData) {
      this.dataResource.chartData[0].forEach((series) => {
        let rating = Number(series[0]);
        let count = series[1];
        if (rating <= NPS_DETRACTORS_RATING_THRESHOLD) {
          detractors += count;
        } else if (rating <= NPS_PASSIVES_RATING_THRESHOLD) {
          passives += count;
        } else if (rating <= NPS_PROMOTERS_RATING_THRESHOLD) {
          promoters += count;
        }
      });
    }

    return { detractors, passives, promoters };
  }

  get npsRespondentCount() {
    let { detractors, passives, promoters } = this.bucketCounts;
    return detractors + passives + promoters;
  }

  get chartData() {
    if (!this.hasData) {
      return '-';
    }
    let { detractors, passives, promoters } = this.bucketCounts;
    let total = detractors + passives + promoters;
    let score = percent(total, promoters) - percent(total, detractors);
    return this._format(score);
  }

  get hasData() {
    return this.dataResource.chartData[0].some((data) => {
      return data[1] > 0;
    });
  }

  _format(score) {
    let unit = 'value';
    let formatter = new Formatters[unit]();
    return formatter.formatCounter(score, REPORTS_WHOLE_NUMBER_PRECISION);
  }
}
